import React, { useEffect, useState } from "react";
import logo from "assets/images/others/host-side-images/logo.png";
import AmbassadorRoleDrawer from "components/drawers/ambassador-side/AmbassadorRoleDrawer";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import { PROFILE_TYPES } from "utils/helpers/enums/shared.enum";
import useUtils from "hooks/useUtils";
import { ROLES } from "utils/helpers/enums/roles.enum";
import useAuth from "../useHooks";
import { UpgradeProfileDTO } from "utils/helpers/models/auth/upgrade-profile.dto";

const AmbassadorRole: React.FC = () => {
  const navigate = useNavigate();
  const { upgradeProfile, getPrivacyPolicy } = useAuth();
  const { createQuery, getQueryParams } = useUtils();
  const { upgrade = false } = getQueryParams();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [profileType, setProfileType] = useState<PROFILE_TYPES | null>(null);
  const [privacyPolicy, setPrivacyPolicy] = useState<any>();

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const headings = [
          "Ambassador Role Description",
          "Role Requirements",
          "Commitment",
          "Our Thank you",
        ];
        const results = await Promise.all(
          headings.map((heading) => getPrivacyPolicy({ heading }))
        );
        setPrivacyPolicy(results.flat());
      } catch (error) {
        console.error("Failed to fetch privacy policies:", error);
      }
    };

    fetchPolicies();
  }, []);




  const handleSeeMore = (id: number) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleChange = (type: PROFILE_TYPES) => {
    setProfileType(type);
  }

  const onSubmit = () => {
    if (upgrade) {
      const body = new UpgradeProfileDTO({ role: ROLES.AMBASSADOR, profileType });
      upgradeProfile(body, true);
    } else {
      const query = createQuery({ role: ROLES.AMBASSADOR, profileType });
      navigate(siteRoutes.signUp + query);
    }
  }

  return (
    <div className="w-full h-screen overflow-y-auto flex flex-col p-6 lg:px-16 lg:py-6">
      {/* Logo */}
      <div className="flex justify-center my-6">
        <img src={logo} alt="logo" className="h-20" />
      </div>

      {/* Form Container */}
      <div className="flex-1 flex justify-center">
        <div className="w-full">
          <div className="w-full mb-6">
            <h1 className="text-3xl font-medium text-blackie">
              Ambassador Role
            </h1>
          </div>
          <div className="mt-4 space-y-4">
            {privacyPolicy?.map((section: any, index: number) => (
              <div key={index} className="p-4 border rounded-lg bg-white">
                <h3 className="font-semibold text-blackie">{section.heading}</h3>
                <div
                  className="text-labelTextColor"
                  dangerouslySetInnerHTML={{
                    __html: section.content
                      .split(" ")
                      .slice(0, 50)
                      .join(" ") + (section.content.split(" ").length > 50 ? "..." : ""),
                  }}
                />

                <button
                  onClick={() => handleSeeMore(index)}
                  className="font-semibold ml-1 text-blackie"
                >
                  See more...
                </button>
              </div>
            ))}
          </div>

        </div>
      </div>
      <div>
        <p className="text-base font-semibold text-ambassadorBlue mt-4">
          Declaration
        </p>

        {/* Checkbox 1 */}
        <div className="flex my-3 items-center">
          <input
            type="checkbox"
            id="leaderCheckbox"
            className="custom-checkbox"
            checked={profileType === PROFILE_TYPES.LEADER}
            onChange={() => handleChange(PROFILE_TYPES.LEADER)}
          />
          <label className="ms-2" htmlFor="leaderCheckbox">
            <p className="text-blackie text-base font-medium">
              Interested in being a{" "}
              <span className="text-ambassadorBlue font-semibold">
                Community Leader
              </span>
              .
            </p>
          </label>
        </div>

        {/* Checkbox 2 */}
        <div className="flex my-3 items-center">
          <input
            type="checkbox"
            id="infoCheckbox"
            className="custom-checkbox"
            checked={profileType === PROFILE_TYPES.BUILDER}
            onChange={() => handleChange(PROFILE_TYPES.BUILDER)}
          />
          <label className="ms-2" htmlFor="infoCheckbox">
            <p className="text-blackie text-base font-medium">
              Interested but need more info,
              <span className="text-ambassadorBlue font-semibold">
                Sign up for info session
              </span>
              .
            </p>
          </label>
        </div>
      </div>

      {/* Continue Button */}
      {profileType && <div className="flex justify-start flex-col gap-2 mt-4">
        <button
          onClick={onSubmit}
          type="button"
          className={`lg:h-[64px] px-6 py-3 text-xl rounded-full text-white w-fit sm:w-1/3 ${profileType
            ? "bg-primaryBlueBg"
            : "bg-gray-400 cursor-not-allowed"
            }`}
          disabled={!profileType}
        >
          {upgrade ? 'Upgrade' : 'Continue'}
        </button>
      </div>}

      {/* Drawer */}
      {open && selectedId !== null && (
        <AmbassadorRoleDrawer
          section={privacyPolicy[selectedId]}
          onClose={() => setOpen(false)}
          isOpen={open}
        />
      )}
    </div>
  );
};

export default AmbassadorRole;
